var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19077_133751)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99814 9.33073C11.3124 9.33073 12.3791 8.2854 12.3791 6.9974C12.3791 5.7094 11.3124 4.66406 9.99814 4.66406C8.68385 4.66406 7.61719 5.7094 7.61719 6.9974C7.61719 8.2854 8.68385 9.33073 9.99814 9.33073ZM9.99814 8.3974C10.7867 8.3974 11.4267 7.7702 11.4267 6.9974C11.4267 6.2246 10.7867 5.5974 9.99814 5.5974C9.20957 5.5974 8.56957 6.2246 8.56957 6.9974C8.56957 7.7702 9.20957 8.3974 9.99814 8.3974Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99963 7.46458C10.2626 7.46458 10.4758 7.25565 10.4758 6.99792C10.4758 6.74018 10.2626 6.53125 9.99963 6.53125C9.73664 6.53125 9.52344 6.74018 9.52344 6.99792C9.52344 7.25565 9.73664 7.46458 9.99963 7.46458Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.625H20V14H0V9.625Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V4.375H0V0Z",
    fill: "#FF6C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19077_133751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/indiaFlag.7d45c317d132417053b15b817da3e0f9.svg";
export { ForwardRef as ReactComponent };